import { useState, useEffect } from 'react';

/**
 * Hook personnalisé pour détecter si l'écran est en mode mobile
 * Seuil : 768px (breakpoint md de Tailwind)
 * @returns {boolean} true si la largeur de l'écran est inférieure à 768px
 */
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Fonction pour détecter si l'écran est mobile
  const checkIsMobile = () => {
    setIsMobile(window.innerWidth < 768);
  };

  useEffect(() => {
    // Vérifier au chargement du composant
    checkIsMobile();

    // Ajouter un event listener pour le resize
    window.addEventListener('resize', checkIsMobile);

    // Nettoyer l'event listener au démontage
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return isMobile;
};

